<ng-container *transloco="let t; read: 'inbox-voicemail-detail-handled-by-button'">
  <app-inbox-handled-by-button [row]="row" [toggleHandledBySelf]="toggleHandledBySelf"></app-inbox-handled-by-button>
</ng-container>
